var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-compensation-type view" }, [
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h3", { staticClass: "center" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("claim.compensationType.title")) + " "),
          ]),
        ]),
        _c("p", { staticClass: "center" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("claim.compensationType.subtitle"))),
          ]),
          _c("br"),
          _c("span", [_vm._v(_vm._s(_vm.$t("claim.compensationType.text")))]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "claim-compensation-type_slider" },
        [
          _c(
            "slider",
            { attrs: { totalSlides: _vm.compensationSlides.length } },
            _vm._l(_vm.compensationSlides, function (compensation, index) {
              return _c(
                "div",
                {
                  staticClass: "claim-compensation-type_slide slide-wrapper",
                  attrs: { slot: "slide-" + index },
                  slot: "slide-" + index,
                },
                [
                  compensation.recommended
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "claim-compensation-type_slide_recommended",
                        },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("claim.compensationType.recommended")
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c("img", {
                    staticClass: "claim-compensation-type_slide_img",
                    attrs: {
                      src: require("./assets/" + compensation.img + ".svg"),
                    },
                  }),
                  _c(
                    "p",
                    { staticClass: "claim-compensation-type_slide_title" },
                    [_vm._v(_vm._s(compensation.title))]
                  ),
                  compensation.amount
                    ? _c(
                        "p",
                        {
                          staticClass: "claim-compensation-type_slide_subtitle",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("claim.compensationType.amount"))
                          ),
                          _c("span", [_vm._v(_vm._s(compensation.amount))]),
                          _vm._v("€"),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "p",
                    { staticClass: "claim-compensation-type_slide_text" },
                    [_vm._v(_vm._s(compensation.text))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass:
                        "claim-compensation-type_slide_link btn mainBlue",
                      on: {
                        click: function ($event) {
                          return _vm.handleLinkClick(compensation.transition)
                        },
                      },
                    },
                    [_c("p", [_vm._v(_vm._s(compensation.link))])]
                  ),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }